import { QueryHookOptions, useQuery } from "@apollo/client";

import { EventCardGrid } from "../../../../components/EventCardGrid";
import Widget from "../../../../components/Marketplace/Widgets/Widget";
import { AuctionNodeConnection } from "../../../../generated/schema";

import { GET_ALL_AUCTIONS } from "../../api/GET_ALL_AUCTIONS";
import { AuctionCard } from "../AuctionCard";

interface Props {
  background?: string;
  id: string;
  options?: QueryHookOptions;
  subtitle: string;
  linkTitle?: string;
  linkUrl?: string;
  themeColor?: string;
  title: React.ReactNode;
  widgetName: string;
}

interface QueryResponse {
  auctions: AuctionNodeConnection;
}

export const AuctionsWidget = ({
  background,
  id,
  linkTitle,
  linkUrl,
  options,
  subtitle,
  themeColor,
  title,
  widgetName,
}: Props) => {
  const { data, error, fetchMore, loading } = useQuery<QueryResponse>(
    GET_ALL_AUCTIONS,
    options,
  );

  const auctions = data?.auctions;

  const fetchMoreAuctions = () =>
    fetchMore({
      variables: { cursor: auctions?.pageInfo?.endCursor },
    });

  return (
    <Widget
      background={background}
      id={id}
      linkTitle={linkTitle}
      linkUrl={linkUrl}
      subtitle={subtitle}
      themeColor={themeColor}
      title={title}
      widgetName={widgetName}
    >
      <EventCardGrid
        error={!!error}
        fetchMore={fetchMoreAuctions}
        hasNextPage={auctions?.pageInfo.hasNextPage}
        loading={loading}
      >
        {auctions &&
          auctions.edges.map((auction) => {
            if (!auction?.node) return null;

            const imageUrl =
              auction.node.auctionphotoSet.edges[0]?.node?.photoMd;

            return (
              <AuctionCard
                key={auction.node.id}
                featured={!!auction.node.featuredRank}
                imageUrl={imageUrl}
                lotCount={auction.node.lotCount}
                lotsRemaining={auction.node.lotRemainingCount}
                openingMaxPrice={auction.node.lotMaxOpeningPrice}
                openingMinPrice={auction.node.lotMinOpeningPrice}
                scheduledStartTime={auction.node.scheduledStartTime}
                slug={auction.node.slug}
                state={auction.node.state}
                title={auction.node.name}
              />
            );
          })}
      </EventCardGrid>
    </Widget>
  );
};
